import { useState } from 'react'
import {
    Button,
    DialogActions,
    MenuItem,
    ListItemText,
    Checkbox,
    OutlinedInput,
    Select,
    FormControl,
    TextField,
    InputLabel,
    FormHelperText,
    Dialog,
    DialogContent,
    DialogTitle,
    Autocomplete,
    styled,
    Chip,
    Box
} from '@mui/material';
import { hebrewTranslations } from '../translations/salesPromotionsDialogTranslation';
import translation from '../translations/customersTranslation';
import { isTestEnv } from "../globals";

const AutocompleteCheckbox = styled(Autocomplete)({
    '& .MuiAutocomplete-paper': {
        maxHeight: '200px',
        width: 'auto',
    },
});


const SalesPromotionsDialog = ({ mockDropdownData, setSnackbar, rolesList, setRolesList, execute, role }) => {
    
    const [errors, setErrors] = useState({});
    const [openSalesPromotionsDialog, setOpenSalesPromotionsDialog] = useState(false);
    const [currentRoleId, setCurrentRoleId] = useState(null);


    const [salesPromotionsData, setSalesPromotionsData] = useState({
        branch: '',
        ordererCustomer: [],
        intOrderType: '',
        extOrderType: '',
        family: [],
        receiveCustomer: '',
    });

    const [salesPromotionsDataDes, setSalesPromotionsDataDes] = useState({
        branch: '',
        ordererCustomer: [],
        intOrderType: '',
        extOrderType: '',
        family: [],
        receiveCustomer: '',
    });

    const getSelectedCount = (key, value) => {
        if (Array.isArray(value)) {

            return `${value.length} ${hebrewTranslations.itemsSelected}`;
        }
        return value ? `1 ${hebrewTranslations.itemSelected}` : hebrewTranslations.noneSelected;
    };


    // Function to handle changes in the Sales Promotions and Samples 
    const handleSalesPromotionsDataChange = (event, newValue, fieldName) => {
        let { name, value } = event.target;
        let updatedValue = value;
        let lastItem = value?.[value?.length - 1];
        let indexToRemove;

        if (fieldName === 'family') {
            name = fieldName;
        }

        const ensureInitializedData = (currentData) => ({
            ...currentData,
            ordererCustomer: currentData.ordererCustomer || [],
            receiveCustomer: currentData.receiveCustomer || [],
            family: currentData.family || [],
            branch: currentData.branch || '',
            intOrderType: currentData.intOrderType || '',
            extOrderType: currentData.extOrderType || '',
        });

        switch (name) {
            case 'ordererCustomer':
            case 'receiveCustomer':
                if (!Array.isArray(value)) {
                    value = [];
                }

                indexToRemove = value.findIndex(item => item?._id === lastItem);
                if (indexToRemove === -1 && lastItem) {
                    const itemToAdd = mockDropdownData[name]?.find(item => item._id === lastItem);
                    if (itemToAdd) {
                        updatedValue = [...(value.filter(item => typeof item === 'object') || []),
                        { _id: itemToAdd._id, des: itemToAdd.custdes }];
                    }
                } else {
                    updatedValue = value.filter((_, index) => index !== indexToRemove && typeof value[index] === 'object');
                }

                setSalesPromotionsDataDes(prevData => ({
                    ...prevData,
                    [name]: updatedValue?.map(customer => customer?.des) || []
                }));
                break;

            case 'family':
                if (newValue !== undefined) {
                    const clickedOption = newValue[newValue.length - 1];
                    const clickedId = clickedOption?._id?.toString();
                    const isAlreadySelected = (salesPromotionsData.family || []).some(
                        f => f._id?.toString() === clickedId
                    );

                    if (isAlreadySelected) {
                        updatedValue = (salesPromotionsData.family || []).filter(
                            f => f._id?.toString() !== clickedId
                        );
                    } else if (clickedOption) {
                        updatedValue = [...(salesPromotionsData.family || []), {
                            _id: clickedOption._id,
                            des: clickedOption.familyDes
                        }];
                    } else {
                        updatedValue = salesPromotionsData.family || [];
                    }

                    setSalesPromotionsDataDes(prevData => ({
                        ...prevData,
                        family: updatedValue.map(f => f.des)
                    }));
                }
                break;

            default:
                updatedValue = value || '';
                break;
        }

        setSalesPromotionsData(prevData => {
            const initializedData = ensureInitializedData(prevData);
            return {
                ...initializedData,
                [name]: (name === 'receiveCustomer' || name === 'family' || name === 'ordererCustomer')
                    ? [...(updatedValue || [])]
                    : (value || '')
            };
        });
    };

    const getItemProperties = (key, item) => {
        switch (key) {
            case 'ordererCustomer':
                return { display: item.custdes, value: item._id };
            case 'branch':
                return { display: item.BRANCHDES, value: item.BRANCHNAME };
            case 'intOrderType':
                return { display: item.name, value: item.code };
            case 'extOrderType':
                return { display: item.description, value: item.code };
            case 'family':
                return { display: `${item.familyName} - ${item.familyDes}`, value: item._id };
            case 'receiveCustomer':
                return { display: item.custdes, value: item._id };
            default:
                return { display: item.name || 'Unknown', value: item.id || item._id || 'Unknown' };
        }
    };

    const handleOpenSalesPromotionsDialog = (roleId) => {
        setCurrentRoleId(roleId);

        const role = rolesList.find(role => role._id === roleId);
        if (role && role.properties[0] && role.properties[0].SalesPromotions) {
            setSalesPromotionsData(role.properties[0].SalesPromotions);
            setSalesPromotionsDataDes({
                ...role.properties[0].SalesPromotions, ordererCustomer: role.properties[0].SalesPromotions.ordererCustomer?.map(customer => customer.des),
                receiveCustomer: role.properties[0].SalesPromotions.receiveCustomer?.map(customer => customer.des), family: role.properties[0].SalesPromotions.family?.map(family => family.des)
            });
        } else {
            setSalesPromotionsData({
                ordererCustomer: '',
                branch: '',
                intOrderType: '',
                extOrderType: '',
                family: '',
                receiveCustomer: '',
            });
        }
        setOpenSalesPromotionsDialog(true);
    };

    const handleSaveSalesPromotionsData = async () => {
        setErrors({});
        let newErrors = {};
        if (!salesPromotionsData.branch) {
            newErrors.branch = hebrewTranslations.selectBranch
        }
        if (!salesPromotionsData.ordererCustomer || salesPromotionsData.ordererCustomer.length === 0) {
            newErrors.ordererCustomer = hebrewTranslations.selectOrderingCustomer;
        }
        if (!salesPromotionsData.family || salesPromotionsData.family.length === 0) {
            newErrors.family = hebrewTranslations.selectProductFamily;
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            const updatedRole = rolesList.find(role => role._id === currentRoleId);
            if (updatedRole) {
                updatedRole.properties[0] = { SalesPromotions: { ...salesPromotionsData, name: hebrewTranslations.salesPromotionsAndSamples } };

                await execute(
                    "POST",
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/roles/updaterole`,
                    updatedRole
                );
                setRolesList(rolesList.map(role =>
                    role._id === currentRoleId ? updatedRole : role
                ));
                setSnackbar({ open: true, message: hebrewTranslations.updateSuccess, severity: 'success' });
            }
        } catch (error) {
            isTestEnv && console.error(error);
            setSnackbar({ open: true, message: hebrewTranslations.updateError, severity: 'error' });
        }
        handleCloseSalesPromotionsDialog();
    };

    // Function to handle closing the dialog
    const handleCloseSalesPromotionsDialog = () => {
        setOpenSalesPromotionsDialog(false);
        setCurrentRoleId(null);
    };

    return (
        <div>
            <Button
                onClick={() => handleOpenSalesPromotionsDialog(role?._id)}
                variant="outlined"
                size="small"
                sx={{
                    ml: 1,
                    backgroundColor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'primary.dark',
                    },
                }}
            >
                { hebrewTranslations.editData }
            </Button>
            <Dialog open={openSalesPromotionsDialog} onClose={handleCloseSalesPromotionsDialog} >
                <DialogTitle>{hebrewTranslations.salesPromotionsPermissions}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal" error={errors.branch}>
                        <InputLabel id="branch-label">{hebrewTranslations.branch}</InputLabel>
                        <Select
                            input={<OutlinedInput label={hebrewTranslations.branch} />}
                            labelId="branch-label"
                            name="branch"
                            value={salesPromotionsData.branch || ''}
                            onChange={handleSalesPromotionsDataChange}
                        >
                            {mockDropdownData.branch && mockDropdownData.branch.length > 0 ? (
                                mockDropdownData.branch.map((item) => {
                                    const { display, value } = getItemProperties('branch', item);
                                    return (
                                        <MenuItem key={value} value={value}>
                                            <ListItemText primary={display + "-" + value} />
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <MenuItem value="">No options available</MenuItem>
                            )}
                        </Select>
                        {errors.branch && <FormHelperText>{errors.branch}</FormHelperText>}
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={errors.ordererCustomer}>
                        <InputLabel id="ordererCustomer-label">{hebrewTranslations.ordererCustomer}</InputLabel>
                        <Select
                            input={<OutlinedInput label={hebrewTranslations.ordererCustomer} />}
                            labelId="ordererCustomer-label"
                            name="ordererCustomer"
                            multiple
                            value={salesPromotionsData.ordererCustomer || []}
                            onChange={handleSalesPromotionsDataChange}
                            renderValue={(selected) => getSelectedCount('ordererCustomer', selected)}
                        >
                            {mockDropdownData.ordererCustomer && mockDropdownData.ordererCustomer.length > 0 ? (
                                mockDropdownData.ordererCustomer.map((item) => {
                                    const { display, value } = getItemProperties('ordererCustomer', item);
                                    return (
                                        <MenuItem key={value} value={value}>
                                            <Checkbox checked={salesPromotionsDataDes?.ordererCustomer?.includes(display) ?? false} />
                                            <ListItemText primary={display} />
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <MenuItem value="">No options available</MenuItem>
                            )}
                        </Select>
                        {errors.ordererCustomer && <FormHelperText>{errors.ordererCustomer}</FormHelperText>}
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <InputLabel id="receiveCustomer-label">{hebrewTranslations.receiveCustomer}</InputLabel>
                        <Select
                            input={<OutlinedInput label={hebrewTranslations.receiveCustomer} />}
                            labelId="receiveCustomer-label"
                            name="receiveCustomer"
                            multiple
                            value={salesPromotionsData.receiveCustomer || []}
                            onChange={handleSalesPromotionsDataChange}
                            renderValue={(selected) => getSelectedCount('receiveCustomer', selected)}
                        >
                            {mockDropdownData.receiveCustomer && mockDropdownData.receiveCustomer.length > 0 ? (
                                mockDropdownData.receiveCustomer.map((item) => {
                                    const { display, value } = getItemProperties('receiveCustomer', item);
                                    return (
                                        <MenuItem key={value} value={value}>
                                            <Checkbox checked={salesPromotionsDataDes?.receiveCustomer?.includes(display) ?? false} />
                                            <ListItemText primary={display} />
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <MenuItem value="">No options available</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <InputLabel id="intOrderType-label">{hebrewTranslations.intOrderType}</InputLabel>
                        <Select
                            input={<OutlinedInput label={hebrewTranslations.intOrderType} />}
                            labelId="intOrderType-label"
                            name="intOrderType"
                            value={salesPromotionsData.intOrderType || ''}
                            onChange={handleSalesPromotionsDataChange}
                        >
                            {mockDropdownData.intOrderType && mockDropdownData.intOrderType.length > 0 ? (
                                mockDropdownData.intOrderType.map((item) => {
                                    return (
                                        <MenuItem key={item._id} value={item.name}>
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <MenuItem value="">No options available</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <InputLabel id="extOrderType-label">{hebrewTranslations.extOrderType}</InputLabel>
                        <Select
                            input={<OutlinedInput label={hebrewTranslations.extOrderType} />}
                            labelId="extOrderType-label"
                            name="extOrderType"
                            value={salesPromotionsData.extOrderType || ''}
                            onChange={handleSalesPromotionsDataChange}
                        >
                            {mockDropdownData.extOrderType && mockDropdownData.extOrderType.length > 0 ? (
                                mockDropdownData.extOrderType.map((item) => {
                                    return (
                                        <MenuItem key={item._id} value={item.description}>
                                            <ListItemText primary={item.description} />
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <MenuItem value="">No options available</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={errors.family}>
                        <AutocompleteCheckbox
                            multiple
                            disableCloseOnSelect
                            options={mockDropdownData.family || []}
                            value={salesPromotionsData.family?._id || []}
                            onChange={(event, newValue) => handleSalesPromotionsDataChange(event, newValue, 'family')}
                            getOptionLabel={(option) => getItemProperties('family', option).display || ''}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option, { selected }) => {
                                const { display, value } = getItemProperties('family', option);
                                return (
                                    <li {...props} key={value} dir="rtl">
                                        <Checkbox checked={salesPromotionsDataDes?.family?.includes(option.familyDes) ?? false} />
                                        {display}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={hebrewTranslations.family}
                                    variant="outlined"
                                    error={!!errors.family}
                                    helperText={errors.family}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <span style={{ marginRight: 'auto', marginLeft: 0 }}>{`${hebrewTranslations.itemsSelected} ${salesPromotionsData.family?.length || 0} `}</span>
                                        ),
                                    }}
                                />
                            )}
                            ListboxProps={{
                                style: {
                                    maxHeight: '200px',
                                },
                            }}
                        />
                    </FormControl>


                    {salesPromotionsData.family?.length > 0 && (
                        <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5, maxHeight: 200, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                            {salesPromotionsData.family.map((f) => {
                                const full = mockDropdownData.family?.find(item => item._id === f._id);
                                const label = full ? `${full.familyName} - ${full.familyDes}` : f.des;
                                return <Chip key={f._id} label={label} size="small" onDelete={() => handleSalesPromotionsDataChange({ target: { name: 'family' } }, salesPromotionsData.family.filter(item => item._id !== f._id).map(item => mockDropdownData.family?.find(m => m._id === item._id)).filter(Boolean), 'family')} />;
                            })}
                        </Box>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseSalesPromotionsDialog}>{hebrewTranslations.cancel}</Button>
                    <Button onClick={handleSaveSalesPromotionsData} color="primary">
                        {hebrewTranslations.save}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default SalesPromotionsDialog
